import angular from 'angular';
import scenes from './scenes';
import CorpActionsAPIService from './services/corpActionsAPIService';

export default angular
  .module('scenes.corpActionsMenus', [scenes])
  .service('corpActionsAPIService', CorpActionsAPIService).name;
